import React, { useState } from "react";
import { toBinary } from "../../../../_helpers";
import axiosInstance from "../../../../axios";
import { ProgressBar } from "../../../Other/ProgressBar/ProgressBar";
import axios from "axios";
import { id } from "date-fns/locale";

export const UploadCourseFile = ({
  file,
  fileID,
  id,
  storageType,
  openPreviewModal,
  removeFile,
  setFormState,
  courseId,
}) => {
  const [progressCount, setProgressCount] = useState(0);
  const [uploader, setUploder] = useState({
    id: 0,
    isUploading: false,
    uploaded: false,
    error: false,
    message: "",
  });
  // const getFileRequestBody = (file, courseId, storageType) => ({
  //   fileName: file.name.substr(0, file.name.lastIndexOf(".")),
  //   fileExt: file.name.substr(file.name.lastIndexOf(".") + 1),
  //   courseId: courseId,
  //   storageType: storageType,
  //   fileSize: file.size,
  // });
  // const startMultipart = async (file, courseId, storageType) => {
  //   setUploder({ ...uploader, isUploading: true, error: false });
  //   return axiosInstance
  //     .post("start/multipart", getFileRequestBody(file, courseId, storageType))
  //     .then(({ data }) => {
  //       return {
  //         key: data.data.Key,
  //         uploadId: data.data.UploadId,
  //         storageType: storageType,
  //       };
  //     })
  //     .catch((error) => error);
  // };
  const getFileRequestBody = async (file, courseId, id, storageType) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onloadend = () => {
        resolve({
          fileName: file.name.substr(0, file.name.lastIndexOf(".")),
          fileExt: file.name.substr(file.name.lastIndexOf(".") + 1),
          courseId: courseId,
          courseDetailId: 0,
          storageType: storageType,
          fileSize: file.size,
          fileBuffer: reader.result, // Add fileBuffer as ArrayBuffer
        });
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const startMultipart = async (file, courseId, id, storageType) => {
    setUploder({ ...uploader, isUploading: true, error: false });

    try {
      const requestBody = await getFileRequestBody(file, courseId, id, storageType);
      //console.log("requestBody", requestBody);
      const formData = new FormData();
      formData.append("file", file);
      formData.append("fileName", requestBody.fileName);
      formData.append("fileExt", requestBody.fileExt);
      formData.append("courseId", requestBody.courseId);
      formData.append("courseDetailId", requestBody.courseDetailId);
      formData.append("storageType", requestBody.storageType);
      formData.append("fileSize", requestBody.fileSize);

      const { data } = await axiosInstance.post("start/multipart", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      //"starting multipart----", data);
      setUploder({
        ...uploader,
        isUploading: false,
        uploaded: !data.error,
        error: data.error,
        message: data.message,
        id: data?.data?.id,
      });
      setFormState(data.data);
      // return true;
      return {
        key: data.data.Key,
        uploadId: data.data.UploadId,
        storageType: storageType,
      };
    } catch (error) {
      console.error("Upload error:", error);
      return error;
    }
  };

  const configOptions = {
    headers: { "content-type": "multipart/form-data" },
    onUploadProgress: (progressEvent) => {
      setProgressCount((progressEvent.loaded / progressEvent.total) * 100);
    },
  };

  const getSignedURL = async ({ key, uploadId, storageType }) => {
    try {
      const endpoint =
        storageType === "CourseScrom"
          ? `signed-url?uploadId=${uploadId}&partNumber=1&key=${key}&storageType=CourseScrom`
          : `signed-url?uploadId=${uploadId}&partNumber=1&key=${key}`;

      const { data } = await axiosInstance.get(endpoint);

      return {
        key,
        uploadId,
        signedURL: data.data,
        storageType,
      };
    } catch (error) {
      console.error("Error fetching signed URL:", error.message);
      return null; // or throw error if needed
    }
  };
  const uploadContent = async ({ key, uploadId, signedURL, storageType }) => {
    try {
      const binaryFile = await toBinary(file);

      const response = await axios.put(signedURL, binaryFile.blob, configOptions);

      return {
        key,
        uploadId,
        eTag: response.headers.etag,
        storageType,
        duration: ["video/mp4", "video/mov"].includes(file.type)
          ? binaryFile.duration
          : 0,
      };
    } catch (error) {
      console.error("Error uploading content:", error.message);
      return null; // or throw error if preferred
    }
  };


  const getCompleteMultipartRequestBody = ({
    key,
    uploadId,
    eTag,
    storageType,
    duration,
  }) => ({
    uploadId: uploadId,
    uploadedParts: [
      {
        PartNumber: 1,
        ETag: `${eTag}`,
      },
    ],
    key: key,
    storageType: storageType,
    duration: Math.round(duration),
  });

  const completeMutipart = async (response) => {
    try {
      const { data } = await axiosInstance.post(
        "complete/multipart",
        getCompleteMultipartRequestBody(response)
      );

      setUploder({
        ...uploader,
        isUploading: false,
        uploaded: !data.error,
        error: data.error,
        message: data.message,
        id: data.data.id,
      });

      setFormState(response);
    } catch (error) {
      console.error("Error completing multipart upload:", error.message);
      setUploder({
        ...uploader,
        isUploading: false,
        uploaded: false,
        error: true,
        message: "Failed to complete multipart upload.",
      });
    }
  };


  const uploadNewFile = async (file, courseId, id, storageType) => {
    startMultipart(file, courseId, id, storageType)
    
    .then(getSignedURL)
    .then(uploadContent)
    .then(completeMutipart)
    .catch((error) => {
      setUploder(false);
      console.log(error);
    });
    
  };

  const removeItem = (file) => () => {
    removeFile(file?.name);
  };

  const deleteFileService = async (id, courseId, storageType) => {
    try {
      const response = await axiosInstance.post("delete/file", {
        courseId,
        id,
        storageType,
      });
      return response;
    } catch (error) {
      console.error("Error deleting file:", error.message);
      return null; // or rethrow the error if needed
    }
  };


  const deleteUploadedFile = (id, name, courseId, storageType) => () => {
    deleteFileService(id, courseId, storageType).then((response) =>
      removeFile(name)
    );
  };

  const deleteExistingAndUploadNewFile = async (
    id,
    file,
    courseId,
    storageType
  ) => {
    setUploder({ ...uploader, isUploading: true, error: false });
    deleteFileService(id, courseId, storageType).then((response) => {
      if (!response.error) {
        uploadNewFile(file, courseId,id, storageType);
      } else {
        setUploder({
          ...uploader,
          isUploading: false,
          error: true,
          message: response.message,
        });
      }
    });
  };

  const uploadFile = (fileId, file, courseId, id, storageType) => {
    if (fileId > 0) {
      deleteExistingAndUploadNewFile(fileId, file, courseId, storageType);
    } else {
      uploadNewFile(file, courseId, id, storageType);
    }
  };

  return (
    <>
      <div className="course_file-display-container">
        <div className="course_file-status-bar">
          <div className="course_fileName">
            {!uploader.isUploading ? (
              <>
                <div className="upload-bar">
                  <span
                    className={`course_file-name ${file.invalid ? "file-error" : ""
                      }`}
                  >
                    {file.name.substr(0, 12)}
                    <button
                      className=" btn-preview"
                      onClick={() => openPreviewModal(file)}
                    >
                      Preview
                    </button>
                  </span>
                  {!file.invalid && (
                    <div
                      className={`${uploader.uploaded
                        ? "course_file-success"
                        : "course-file-upload"
                        }`}
                      title={uploader.uploaded ? "uploaded" : "upload"}
                      onClick={() =>
                        uploadFile(fileID, file, courseId, id, storageType)
                      }
                    ></div>
                  )}

                  <div
                    className="course_file-remove "
                    onClick={
                      uploader.uploaded
                        ? deleteUploadedFile(
                          uploader.id,
                          file.name,
                          courseId,
                          storageType
                        )
                        : removeItem(file)
                    }
                  >
                    <div className="course_close">
                      <div>
                        <i
                          className={`icon ${uploader.uploaded ? "trash" : "check"
                            }`}
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <ProgressBar
                barWidth={`${Math.round(progressCount)}%`}
                barMinWidth="0%"
                progressCount={progressCount}
              />
            )}
          </div>
        </div>
      </div>
      {uploader.error && (
        <div className="course_file-error-message">
          <span className="course_file-error-message">{uploader.error}</span>
        </div>
      )}
    </>
  );
};
